export default __webpack_public_path__ + "static/media/icon-harmony.d86e8876.svg";